import { create } from 'zustand';
import type { AgentTaskGroup } from './canvas-types';

export function createCloneActivityStore() {
  return create<{runs:Record<number,string[]>;start:(projectId:number,id:string)=>void;finish:(projectId:number,id:string)=>void}>(set=>({
    runs:{},
    start:(projectId,id)=>set(state=>({runs:{...state.runs,[projectId]:[...new Set([...(state.runs[projectId]??[]),id])]}})),
    finish:(projectId,id)=>set(state=>({runs:{...state.runs,[projectId]:(state.runs[projectId]??[]).filter(run=>run!==id)}})),
  }));
}
/** Live-only activity: saved unfinished history must not resurrect a working dot. */
export const useCloneActivity = createCloneActivityStore();

export function createCloneProgress(id:string,count:number):AgentTaskGroup {
  return {id,label:`Cloning ${count} ad${count===1?'':'s'}`,status:'active',iterationIndex:0,steps:[
    {id:`${id}-study`,toolName:'clone_study',friendlyLabel:'Reviewing the source ad',status:'running'},
    ...Array.from({length:count},(_,i)=>({id:`${id}-gen-${i}`,toolName:'clone_generate',friendlyLabel:`Generating clone ${i+1}`,status:'pending' as const})),
  ]};
}

/** Interpret documented public SSE milestones; never use provider reasoning text. */
export function applyCloneProgress(group:AgentTaskGroup,event:string,data:Record<string,unknown>):AgentTaskGroup {
  const steps=group.steps.map(step=>({...step}));
  const study=steps[0];
  const index=typeof data.index==='number'&&Number.isInteger(data.index)?data.index:-1;
  const step=index>=0?steps[index+1]:undefined;
  if(event==='step'&&study) study.status=data.status==='completed'?'success':'running';
  if(event==='variation_progress'&&step&&step.status!=='success') {
    if(data.status==='failed'){step.status='error';step.error='This clone could not finish.';}
    else if(data.status==='running'){
      step.status='running';
      step.toolName=data.stage==='qa'?'clone_qa':typeof data.attempt==='number'&&data.attempt>1?'clone_retry':'clone_generate';
      step.friendlyLabel=data.stage==='qa'?`Checking clone ${index+1}`:step.toolName==='clone_retry'?`Revising clone ${index+1}`:`Generating clone ${index+1}`;
    }
  }
  if(event==='variation_complete'&&step&&typeof data.imageUrl==='string'&&data.imageUrl){step.status='success';step.summary='Image delivered';}
  if(event==='done'||event==='error'){
    for(const pending of steps)if(pending.status==='running'||pending.status==='pending')pending.status=pending===study&&event==='done'?'success':'error';
    return {...group,steps,status:steps.slice(1).some(s=>s.status==='success')?'completed':'failed'};
  }
  return {...group,steps};
}
